module.exports = __webpack_public_path__ + "img/8.9c33b801.jpg";